<template>
  <div class="vitamines-mineraux-page">
    <!-- Header / vidéo -->
    <section class="header-section">
      <div class="carousel">
        <div class="carousel-videos" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <div v-for="(video, index) in videos" :key="index" class="carousel-video">
            <video
              :src="video"
              autoplay
              muted
              loop
              playsinline
              webkit-playsinline
              id="VideoWorker-0"
              class="video-player"
            ></video>
            <div class="carousel-text">
              <h1 class="page-title">Vitamines & Minéraux</h1>
            </div>
          </div>
        </div>

        <div class="carousel-dots">
          <span
            v-for="(video, index) in videos"
            :key="index"
            :class="{ active: currentIndex === index }"
            class="carousel-dot"
            @click="goToSlide(index)"
          ></span>
        </div>
      </div>
    </section>

    <div class="breadcrumb">
      <a href="/">Accueil</a> >
      <RouterLink to="/produits">Produits</RouterLink> >
      <RouterLink to="/vitamines-mineraux">Vitamines & Minéraux</RouterLink>
    </div>

    <div class="shop-container">
      <!-- Filtres -->
      <aside class="sidebar">
        <h2>Filtres</h2>

        <div class="filter-options-item">
          <h3>Marque</h3>
          <form>
            <li v-for="filter in filters.marque" :key="filter.value">
              <input
                type="checkbox"
                :value="filter.value"
                v-model="selectedFilters.marque"
              />
              <span class="label">{{ filter.label }}</span>
              <span class="count">({{ filter.count }})</span>
            </li>
          </form>
        </div>

        <div class="filter-options-item">
          <h3>Prix</h3>
          <input type="range" :min="priceRange.min" :max="priceRange.max" v-model="priceMin" />
          <input type="range" :min="priceRange.min" :max="priceRange.max" v-model="priceMax" />
          <div>{{ priceMin }} - {{ priceMax }} MAD</div>
        </div>

        <div class="filter-options-item">
          <h3>Formulation</h3>
          <form>
            <li v-for="filter in filters.formulation" :key="filter.value">
              <input
                type="checkbox"
                :value="filter.value"
                v-model="selectedFilters.formulation"
              />
              <span class="label">{{ filter.label }}</span>
              <span class="count">({{ filter.count }})</span>
            </li>
          </form>
        </div>

        <div class="filter-options-item">
          <div class="filter-options-title" role="tab" tabindex="0" @click="toggleFilterContent('forme')">
            <h3>Forme</h3>
          </div>
          <div class="filter-options-content" v-show="isFormeExpanded" role="tabpanel">
            <form autocomplete="off">
              <li v-for="(option, index) in filters.forme" :key="index" class="item">
                <label>
                  <input
                    type="checkbox"
                    :value="option.value"
                    v-model="selectedFilters.forme"
                  />
                  <span class="label">{{ option.label }}</span>
                  <span class="count">({{ option.count }})</span>
                </label>
              </li>
            </form>
          </div>
        </div>
      </aside>

      <!-- Produits -->
      <main class="products-section">
        <p class="page-description">
          Découvrez notre large gamme de vitamines et de minéraux, essentiels pour le bien-être et la santé.
        </p>

        <div class="toolbar toolbar-products">
          <div class="display-mode">
            <button @click="setDisplayMode('grid')" :class="{ active: displayMode === 'grid' }">
              <i class="fas fa-th-large"></i>
            </button>
            <button @click="setDisplayMode('list')" :class="{ active: displayMode === 'list' }">
              <i class="fas fa-list"></i>
            </button>
          </div>

          <div class="field limiter">
            <label for="limiter" class="label"><span>Afficher</span></label>
            <select id="limiter" v-model.number="itemsPerPage" class="limiter-options">
              <option :value="10">10</option>
              <option :value="16">16</option>
              <option :value="22">22</option>
              <option :value="30">30</option>
            </select>
          </div>

          <div class="toolbar-sorter sorter">
            <label for="sorter" class="sorter-label">Trier par</label>
            <select id="sorter" v-model="sortBy" class="sorter-options">
              <option value="name">Produits</option>
              <option value="price">Prix</option>
            </select>
          </div>
        </div>

        <!-- Grille / Liste -->
        <div :class="displayMode === 'grid' ? 'product-grid' : 'product-list'">

          <div class="product-item" v-for="(product, index) in paginatedProducts" :key="index">

            <img :src="product.image" :alt="product.name" class="product-image" />
                       <div class="wishlist-icon" @click="toggleWishlist(product)">
  <i :class="isInWishlist(product) ? 'fas fa-heart active' : 'far fa-heart'"></i>
</div>
            <h3 class="product-name">{{ product.name }}</h3>
            <p class="product-price">{{ product.price }} MAD</p>
            <p class="product-description" v-if="displayMode === 'grid'">{{ product.description }}</p>

            <button class="add-to-cart-btn" @click="addToCart(product)">🛒 Ajouter</button>

            <button class="view-details-btn" @click="openModal(product)">Voir détails</button>


          </div>
        </div>
      </main>
    </div>

    <!-- MODAL DÉTAILS PRODUIT -->
    <div v-if="isModalOpen" class="modal" @click.self="handleOverlay">
      <div class="modal-content" role="dialog" aria-modal="true">
        <button class="close-btn" @click="closeModal" aria-label="Fermer">&times;</button>

        <div class="modal-body">
          <div class="modal-left">
            <img :src="modalProduct?.image" :alt="modalProduct?.name" class="modal-image" />
          </div>
          <div class="modal-right">
            <h3 class="modal-title">{{ modalProduct?.name }}</h3>
            <p class="modal-price"><strong>{{ modalProduct?.price }} MAD</strong></p>
            <p class="modal-desc">{{ modalProduct?.description }}</p>

            <ul class="modal-meta">
              <li><strong>Marque :</strong> {{ labelForMarque(modalProduct?.marque) }}</li>
              <li><strong>Forme :</strong> {{ labelForForme(modalProduct?.forme) }}</li>
              <li><strong>Formulation :</strong> {{ labelForFormulation(modalProduct?.formulation) }}</li>
            </ul>

            <div class="modal-actions">
              <button class="add-to-cart-btn" @click="addToCart(modalProduct)">Ajouter au panier</button>
              <button class="view-details-btn" @click="closeModal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
<!-- MODAL CONFIRMATION AJOUT PANIER -->
<div v-if="addConfirmOpen" class="modal" @click.self="closeAddConfirm">
  <div class="confirm-box" role="dialog" aria-modal="true">
    <button class="close-btn" aria-label="Fermer" @click="closeAddConfirm">&times;</button>

    <div class="alert success">
      Le produit <strong>{{ addedProduct?.name }}</strong> a été ajouté à votre panier.
    </div>

    <div class="confirm-actions">
      <button class="btn primary" @click="continueShopping">
        Continuer ({{ countdown }})
      </button>
      <button class="btn outline" @click="goToCart">Voir Panier</button>
    </div>
  </div>
</div>

<!-- TOAST WISHLIST -->
<transition name="fade">
  <div v-if="showWishlistToast" class="wishlist-toast">
    {{ wishlistToast }}
  </div>
</transition>


    <!-- /MODAL -->
  </div>
</template>



<script>
import { store } from "@/Store";
import axios from "axios";
import { wishlistStore } from "@/wishlisteStore";

export default {
  name: "ShopI",
  data() {
    return {
      sortBy: "name",
      itemsPerPage: 10,
      displayMode: "grid",
      isModalOpen: false,
      modalProduct: null,
      currentIndex: 0,
      addConfirmOpen: false,
      addedProduct: null,
      countdown: 3,
      countdownInterval: null,
      wishlist: [],
      wishlistItems: [],
      wishlistToast: null, // message du toast
     showWishlistToast: false, // afficher / masquer

      videos: [require("@/assets/vedio.mp4")],

      products: [
        { id: "vitC",name: "Vitamine C", description: "Un puissant antioxydant pour renforcer le système immunitaire.", price: 150, image: "vita_C.jpeg", marque: "gph", forme: 9320, formulation: "bio" },
        { id: "vitD",name: "Vitamine D", description: "Essentielle pour des os solides et un bon fonctionnement musculaire.", price: 250, image: "vita_D.jpg", marque: "bio", forme: 9321, formulation: "bio" },
        { id: "magn",name: "Magnésium", description: "Aide à maintenir un métabolisme énergétique normal.", price: 600, image: "mag.jpg", marque: "bio", forme: 9323, formulation: "bio" },
        { id: "vitE",name: "Vitamine E", description: "Un puissant antioxydant pour renforcer le système immunitaire.", price: 800, image: "path-to-your-image.jpg", marque: "gph", forme: 9320, formulation: "bio" },
        { id: "vitD1",name: "Vitamine D", description: "Essentielle pour des os solides et un bon fonctionnement musculaire.", price: 250, image: "path-to-your-image.jpg", marque: "bio", forme: 9321, formulation: "bio" },
        { id: "magn1",name: "Magnésium", description: "Aide à maintenir un métabolisme énergétique normal.", price: 600, image: "path-to-your-image.jpg", marque: "bio", forme: 9323, formulation: "bio" },
        { id: "vitC1",name: "Vitamine C", description: "Un puissant antioxydant pour renforcer le système immunitaire.", price: 150, image: "path-to-your-image.jpg", marque: "gph", forme: 9320, formulation: "bio" },
        { id: "vitD2",name: "Vitamine D", description: "Essentielle pour des os solides et un bon fonctionnement musculaire.", price: 250, image: "path-to-your-image.jpg", marque: "bio", forme: 9321, formulation: "bio" },
        { id: "magn3",name: "Magnésium", description: "Aide à maintenir un métabolisme énergétique normal.", price: 600, image: "path-to-your-image.jpg", marque: "bio", forme: 9323, formulation: "bio" },
        { id: "vitC3",name: "Vitamine C", description: "Un puissant antioxydant pour renforcer le système immunitaire.", price: 150, image: "path-to-your-image.jpg", marque: "gph", forme: 9320, formulation: "bio" },
        { id: "vitD3",name: "Vitamine D", description: "Essentielle pour des os solides et un bon fonctionnement musculaire.", price: 250, image: "path-to-your-image.jpg", marque: "bio", forme: 9321, formulation: "bio" },
        { id: "magn2",name: "Magnésium", description: "Aide à maintenir un métabolisme énergétique normal.", price: 600, image: "path-to-your-image.jpg", marque: "bio", forme: 9323, formulation: "bio" },
      ],

      filters: {
        marque: [
          { label: "GPH Diffusion", value: "gph", count: 14 },
          { label: "Bio Atlantic", value: "bio", count: 21 },
        ],
        formulation: [{ label: "Certifié Bio", value: "bio", count: 35 }],
        forme: [
          { label: "Comprimés", value: 9320, count: 18 },
          { label: "Gélules", value: 9321, count: 8 },
          { label: "Poudre", value: 9322, count: 3 },
          { label: "Ampoules", value: 9323, count: 1 },
          { label: "Graines", value: 9324, count: 5 },
        ],
      },

      priceRange: { min: 100, max: 1000 },
      priceMin: 100,
      priceMax: 1000,

      selectedFilters: { marque: [], formulation: [], forme: [] },
      isFormeExpanded: true,
      interval: null,
    };
  },

 async mounted() {
    const video = document.getElementById("VideoWorker-0");
    if (video) {
      video.muted = true;
      video.loop = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.controls = false;
      video.play().catch(() => {});
    }

    // Fermer la modal avec la touche ESC
    window.addEventListener("keydown", this.onKeydown);

     await this.fetchWishlist();
  },

beforeUnmount() {
  if (this.addConfirmTimer) clearTimeout(this.addConfirmTimer);
  window.removeEventListener("keydown", this.onKeydown);
},

  computed: {
    filteredProducts() {
      // 1) Filtre
      let list = this.products.filter((product) => {
        const matchesPrice = product.price >= this.priceMin && product.price <= this.priceMax;
        const matchesMarque = !this.selectedFilters.marque.length || this.selectedFilters.marque.includes(product.marque);
        const matchesFormulation = !this.selectedFilters.formulation.length || this.selectedFilters.formulation.includes(product.formulation);
        const matchesForme = !this.selectedFilters.forme.length || this.selectedFilters.forme.includes(product.forme);
        return matchesPrice && matchesMarque && matchesFormulation && matchesForme;
      });

      // 2) Tri
      if (this.sortBy === "name") {
        list.sort((a, b) => a.name.localeCompare(b.name));
      } else if (this.sortBy === "price") {
        list.sort((a, b) => a.price - b.price);
      }
      return list;
    },

    paginatedProducts() {
      const startIndex = 0;
      const endIndex = this.itemsPerPage;
      return this.filteredProducts.slice(startIndex, endIndex);
    },

    cartCount() {
  // total de quantités dans le panier (ou mets store.cart.length si tu préfères le nb d’articles)
  return store.cart.reduce((sum, it) => sum + (it.quantity || 1), 0);
},

  },

  methods: {
    toggleFilterContent(key) {
      if (key === "forme") this.isFormeExpanded = !this.isFormeExpanded;
    },

    setDisplayMode(mode) {
      this.displayMode = mode;
    },

addToCart(product) {
    store.addToCart(product);
    this.addedProduct = product;
    this.addConfirmOpen = true;
    document.body.style.overflow = 'hidden';
    this.startAutoDismiss();        // démarre le décompte
  },

  startAutoDismiss() {
    this.clearCountdown();
    this.countdown = 3;             // (3) -> (2) -> (1) -> auto-close
    this.countdownInterval = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown <= 0) {
        this.closeAddConfirm();
      }
    }, 1000);
  },

  clearCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  },

  continueShopping() {
    this.closeAddConfirm();
  },

  goToCart() {
    this.closeAddConfirm();
    this.$router.push('/panier');
  },

  closeAddConfirm() {
    this.clearCountdown();
    this.addConfirmOpen = false;
    this.addedProduct = null;
    document.body.style.overflow = '';
  },
    openModal(product) {
      this.modalProduct = product;
      this.isModalOpen = true;
      document.body.style.overflow = "hidden"; // empêcher le scroll derrière
    },

    closeModal() {
      this.isModalOpen = false;
      this.modalProduct = null;
      document.body.style.overflow = ""; // réactiver le scroll
    },

    handleOverlay(e) {
      // Ferme si on clique en dehors du contenu
      if (e.target === e.currentTarget) this.closeModal();
    },

    onKeydown(e) {
      if (e.key === 'Escape') {
    if (this.isModalOpen) this.closeModal();        // ta modale détail
    if (this.addConfirmOpen) this.closeAddConfirm(); // la modale confirmation
  }
    },

    labelForMarque(value) {
      const m = this.filters.marque.find((x) => x.value === value);
      return m ? m.label : value;
    },
    labelForForme(value) {
      const f = this.filters.forme.find((x) => x.value === value);
      return f ? f.label : value;
    },
    labelForFormulation(value) {
      const f = this.filters.formulation.find((x) => x.value === value);
      return f ? f.label : value;
    },

    goToSlide(i) {
      this.currentIndex = i;
    },

 async fetchWishlist() {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) return;
        const res = await axios.get("http://localhost:2028/api/wishlist", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.wishlistItems = res.data || [];
      } catch (err) {
        console.warn("Erreur récupération wishlist:", err);
      }
    },

    // vérifier si un produit est déjà dans la wishlist
    isInWishlist(product) {
      return this.wishlistItems.some(
        (item) =>
          item.productId === product._id || item.productId === product.id
      );
    },

async toggleWishlist(product) {
  const token = sessionStorage.getItem("token");
  if (!token) {
    alert("Connectez-vous pour utiliser la wishlist ❤️");
    this.$router.push("/connexion");
    return;
  }

  try {
    if (this.isInWishlist(product)) {
      // Suppression
      await axios.delete(
        `http://localhost:2028/api/wishlist/${product._id || product.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      this.wishlistItems = this.wishlistItems.filter(
        (p) => p.productId !== (product._id || product.id)
      );

      //Décrémente le compteur global
      wishlistStore.decrement();

      // Toast
      this.triggerWishlistToast("Produit retiré de votre wishlist 💔");
    } else {
      // Ajout
      await axios.post(
        "http://localhost:2028/api/wishlist",
        {
          productId: product._id || product.id,
          name: product.name,
          price: product.price,
          image: product.image,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      this.wishlistItems.push({
        productId: product._id || product.id,
        name: product.name,
        price: product.price,
        image: product.image,
      });

      // Incrémente le compteur global
      wishlistStore.increment();

      // Toast
      this.triggerWishlistToast("Produit ajouté à votre wishlist ❤️");
    }
  } catch (err) {
    console.error("Erreur wishlist:", err);
  }
},

triggerWishlistToast(message) {
  this.wishlistToast = message;
  this.showWishlistToast = true;

  // disparaît automatiquement après 2 secondes
  setTimeout(() => {
    this.showWishlistToast = false;
  }, 2000);
},

  
  },
};
</script>

<style scoped>
/* ====== MODAL ====== */
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
}

.modal-content {
  background: #fff;
  width: 100%;
  max-width: 920px;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
  position: relative;
  overflow: hidden;
  animation: scaleIn .18s ease-out;
}

@keyframes scaleIn {
  from { transform: scale(.98); opacity: .6; }
  to   { transform: scale(1); opacity: 1; }
}

.close-btn {
  position: absolute;
  top: 10px; right: 12px;
  width: 36px; height: 36px;
  border: none; border-radius: 8px;
  background: #f1f1f1;
  color: #222; font-size: 22px; line-height: 1;
  cursor: pointer;
}
.close-btn:hover { background: #e7e7e7; }

.modal-body {
  display: grid;
  grid-template-columns: 1.1fr 1.3fr;
  gap: 16px;
  padding: 22px;
}
.modal-left, .modal-right { display: flex; flex-direction: column; }
.modal-image {
  width: 100%; height: 100%;
  object-fit: cover; border-radius: 12px;
  background: #fafafa;
}
.modal-title { margin: 4px 0 4px; font-size: 22px; color: #1d1d1f; }
.modal-price { margin: 0 0 10px; font-size: 18px; color: #13795b; }
.modal-desc { color: #5d6b75; margin-bottom: 12px; }

.modal-meta { list-style: none; padding: 0; margin: 0 0 16px; }
.modal-meta li { margin: 6px 0; color: #334; }

.modal-actions { display: flex; gap: 10px; }
.modal-actions .add-to-cart-btn,
.modal-actions .view-details-btn {
  padding: 10px 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}
.modal-actions .add-to-cart-btn { background: #00998B; color: #fff; }
.modal-actions .add-to-cart-btn:hover { background: #007c71; }
.modal-actions .view-details-btn { background: #eef2f4; color: #222; }
.modal-actions .view-details-btn:hover { background: #e3e7ea; }

@media (max-width: 860px) {
  .modal-body { grid-template-columns: 1fr; }
}

/* ====== EXISTANTS (tes styles) ====== */
.shop-container {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 20px;
  padding: 20px;
}

.carousel { position: relative; overflow: hidden; width: 100%; height: 300px; }
.carousel-video { position: relative; min-width: 100%; display: flex; align-items: center; justify-content: center; z-index: 1!important; }
.video-player { width: 100%; height: 100%; object-fit: cover; border-radius: 0; pointer-events: none; position: relative!important; z-index: 1!important; }

.carousel-text {
  position: absolute; top: 10%; left: 50%; transform: translateX(-50%);
  color: #333; padding: 0 30px; font-size: 24px; text-align: center; z-index: 2;
  width: 70%; box-sizing: border-box; font-family: 'Helvetica', sans-serif; border-radius: 15px;
}

.sidebar { background: #f4f4f4; padding: 20px; }
.filter-options-item { margin-bottom: 20px; }
.filter-options-item h3 { font-size: 1.2em; margin-bottom: 10px; }
.filter-options-item form li { list-style: none; margin-bottom: 10px; }

.vitamines-mineraux-page { padding: 0; font-family: 'Poppins', sans-serif; }

.toolbar-products {
  display: flex; justify-content: space-between;
  margin: 0 20px 40px;
}
.display-mode button {
  background: #fff; border: 1px solid #ddd; padding: 10px; margin-right: 10px; cursor: pointer; transition: .3s;
}
.display-mode button.active { background: #00998B; color: #fff; }

.field.limiter { display: flex; flex-direction: row; gap: 10px; align-items: center; font-size: 16px; }

.toolbar-sorter { display: flex; flex-direction: row; gap: 10px; align-items: center; font-size: 16px; }
.sorter-options { padding: 5px; background: #f4f4f4; border: 1px solid #ddd; border-radius: 5px; font-size: 10px; color: #2c3e50; cursor: pointer; }
.sorter-options:focus { outline: none; border-color: #00998b; }

.product-list .product-image { width: 20%; height: auto; }
.product-list { display: block; }

.header-section { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 0; }
.page-title { font-size: 2.5em; margin-bottom: 10px; }

.breadcrumb { font-size: 10px; color: #888; margin-top: 0; padding: 10px 50px; }
.breadcrumb a { color: #1c1c1d; text-decoration: none; transition: .3s; }
.breadcrumb a:hover { color: #0056b3; }

.page-description { font-size: 18px; color: #2c3e50; text-align: center; margin-bottom: 30px; }
.products-section { margin-top: 20px; text-align: center; }

.product-grid {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px; padding: 0 20px;
}
.product-item {
  position: relative; /* ✅ indispensable pour que l'icône se positionne correctement */
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,.1);
  text-align: center;
  transition: transform .3s;
}

.product-item:hover { transform: translateY(-8px); }
.product-image { width: 100%; height: auto; border-radius: 8px; margin-bottom: 15px; }
.product-name { font-size: 1.2em; color: #2c3e50; }
.product-price { font-size: 1.1em; color: #27ae60; font-weight: bold; margin: 10px 0; }
.product-description { font-size: .95em; color: #7f8c8d; margin-bottom: 15px; }

.add-to-cart-btn, .view-details-btn {
  background: #00998B; color: #fff; border: none; padding: 10px 15px; margin: 5px;
  border-radius: 5px; cursor: pointer; transition: background-color .3s; font-size: .9em;
}
.add-to-cart-btn:hover, .view-details-btn:hover { background: #00796B; }

/* Responsive (existants) */
@media (max-width: 1024px) {
  .shop-container { grid-template-columns: 1fr; }
  .sidebar { display: none; }
  .carousel-text { font-size: 18px; width: 90%; }
  .toolbar-products { flex-direction: column; align-items: center; gap: 10px; }
  .product-grid { grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); }
  .page-title { font-size: 2em; }
  .product-item { padding: 15px; }
  .add-to-cart-btn, .view-details-btn { padding: 8px 12px; font-size: .8em; }
}
@media (max-width: 480px) {
  .carousel-text { font-size: 16px; }
  .product-grid { grid-template-columns: 1fr; }
  .page-title { font-size: 1.8em; }
  .product-item { padding: 10px; }
  .add-to-cart-btn, .view-details-btn { padding: 6px 10px; font-size: .7em; }
}

/* --- MODAL OVERLAY --- */
.modal {
  position: fixed;
  inset: 0;                    /* top:0 right:0 bottom:0 left:0 */
  background: rgba(0,0,0,.45);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  display: flex;
  align-items: flex-end;       /* mobile: bottom sheet */
  justify-content: center;
  padding: 12px;               /* garde un léger padding */
  z-index: 1000;
  animation: modal-fade-in .18s ease-out;
}

/* --- CONTENU --- */
.modal-content {
  position: relative;
  width: 100%;
  max-height: 85vh;            /* évite de dépasser l’écran */
  overflow-y: auto;
  background: #fff;
  border-radius: 16px 16px 12px 12px; /* mobile: coins haut arrondis */
  box-shadow: 0 10px 28px rgba(0,0,0,.18);
  padding: 16px;
  animation: modal-slide-up .18s ease-out;
}

/* Titre, prix, etc. (optionnel) */
.modal-title { margin: 0 0 8px; font-size: 18px; font-weight: 700; color: #1d1d1f; }
.modal-price { color: #0a8f7d; font-weight: 700; margin-bottom: 10px; }
.modal-body  { color: #495057; line-height: 1.5; }
.modal-actions { display: flex; gap: 10px; margin-top: 14px; flex-wrap: wrap; }

/* Bouton fermer */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  line-height: 1;
  font-size: 22px;
  width: 36px; height: 36px;
  display: grid; place-items: center;
  border-radius: 999px;
  background: rgba(0,0,0,.06);
  color: #222;
  cursor: pointer;
  user-select: none;
  border: none;               
}
.close-btn:hover { background: rgba(0,0,0,.12); }


.modal-grid {
  display: grid;
  grid-template-columns: 1fr; 
  gap: 16px;
}
.modal-image {
  width: 100%;
  border-radius: 10px;
  background: #f6f7f8;
  object-fit: cover;
  max-height: 36vh;          
}

/* --- TABLETTE --- */
@media (min-width: 640px) {
  .modal {
    align-items: center;       
  }
  .modal-content {
    width: 520px;
    max-height: 90vh;
    border-radius: 14px;
    padding: 18px;
  }
}

/* --- DESKTOP --- */
@media (min-width: 1024px) {
  .modal-content {
    width: 720px;
    padding: 22px;
  }
  .modal-grid {
    grid-template-columns: 1.1fr 1.2fr; /* image | détails */
    align-items: start;
  }
  .modal-image {
    max-height: 60vh;
  }
  .modal-title { font-size: 22px; }
}


/* Petites animations */
@keyframes modal-fade-in {
  from { opacity: 0; } to { opacity: 1; }
}
@keyframes modal-slide-up {
  from { transform: translateY(12px); opacity: .96; }
  to   { transform: translateY(0);    opacity: 1; }
}


@media (prefers-reduced-motion: reduce) {
  .modal, .modal-content { animation: none !important; }
}




.autoclose-hint {
  margin: 8px 0 2px;
  text-align: center;
  color: #667085;
  font-size: 0.9rem;
}

/* Boîte de confirmation */
.confirm-box {
  background: #fff;
  width: min(540px, 92vw);
  border-radius: 10px;
  padding: 20px;
  position: relative;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
}

/* Bandeau succès */
.alert.success {
  background: #e8f5e9;
  color: #1b5e20;
  border: 1px solid #c8e6c9;
  padding: 12px;
  border-radius: 6px;
  text-align: center;
  margin-bottom: 14px;
}

/* Boutons */
.confirm-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 6px;
  flex-wrap: wrap;
}
.btn.primary {
  background: #00998B;
  color: #fff;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}
.btn.primary:hover { background: #007c71; }
.btn.outline {
  background: #fff;
  color: #00998B;
  border: 2px solid #00998B;
  padding: 10px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}
.btn.outline:hover { background: #f3fffd; }



/* =====  MODE SOMBRE ===== */
@media (prefers-color-scheme: dark) {

  /* --- Général --- */
  body, .shop-container, .vitamines-mineraux-page {
    background-color: #0f141b !important;
    color: #e6edf1 !important;
  }

  .sidebar {
    background: #161d27 !important;
    color: #e6edf1 !important;
  }

  .filter-options-item h3 {
    color: #00bfa5 !important;
  }

  /* --- Modale --- */
  .modal {
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(3px);
  }

  .modal-content {
    background: #10151c;
    color: #e6edf1;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  }

  .modal-title {
    color: #aef7f0;
  }

  .modal-price {
    color: #00bfa5;
  }

  .modal-desc {
    color: #cdd4da;
  }

  .modal-meta li {
    color: #9fa8b1;
  }

  .modal-image {
    background: #18222e;
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.08);
    color: #e6edf1;
  }
  .close-btn:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .modal-actions .add-to-cart-btn {
    background: #00998B;
    color: #fff;
  }
  .modal-actions .add-to-cart-btn:hover {
    background: #00bfa5;
  }

  .modal-actions .view-details-btn {
    background: #1a2532;
    color: #e6edf1;
  }
  .modal-actions .view-details-btn:hover {
    background: #243546;
  }

  /* --- Produits --- */
  .product-item {
    background: #1a1f29;
    color: #dce3ea;
    box-shadow: 0 2px 8px rgba(0,0,0,.6);
  }

  .product-name {
    color: #aef7f0;
  }

  .product-price {
    color: #00bfa5;
  }

  .product-description {
    color: #9fa8b1;
  }

  .add-to-cart-btn,
  .view-details-btn {
    background: #00998B;
    color: #fff;
  }
  .add-to-cart-btn:hover,
  .view-details-btn:hover {
    background: #00bfa5;
  }

  /* --- Toolbar et texte --- */
  .toolbar-products,
  .page-description,
  .breadcrumb a,
  .display-mode button {
    color: #e6edf1 !important;
    background-color: transparent !important;
  }

  .display-mode button.active {
    background: #00998B;
    color: #fff;
  }

  .sorter-options {
    background: #1f2833;
    color: #d1dae3;
    border-color: #2e3a49;
  }

  /* --- Table, alertes, confirmations --- */
  .confirm-box {
    background: #10151c;
    color: #e6edf1;
    box-shadow: 0 10px 30px rgba(0,0,0,0.9);
  }

  .alert.success {
    background: #113a26;
    color: #bdf0cc;
    border-color: #1f6845;
  }

  .btn.primary {
    background: #00998B;
    color: #fff;
  }
  .btn.primary:hover {
    background: #00bfa5;
  }

  .btn.outline {
    background: transparent;
    color: #aef7f0;
    border: 2px solid #00998B;
  }
  .btn.outline:hover {
    background: #0d1a1f;
  }

  .autoclose-hint {
    color: #8b98a3;
  }
}

.actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
}

/* ==============================
    ANIMATION COEUR WISHLIST
============================== */

.product-item {
  position: relative; /* Nécessaire pour positionner le cœur */
}

.wishlist-icon {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 1.6em;
  cursor: pointer;
  color: #b8b8b8;
  z-index: 10;
  transition: transform 0.25s ease, color 0.25s ease;
}


/* Effet au survol */
.wishlist-icon:hover {
  transform: scale(1.15);
  color: #ff6b81;
}

/* Cœur actif (produit en favoris) */
.wishlist-icon .fa-heart.active {
  color: #e0245e;
  animation: heartPop 0.3s ease-in-out;
  filter: drop-shadow(0 0 6px rgba(224, 36, 94, 0.4));
}

/*  Animation rebond + halo */
@keyframes heartPop {
  0% {
    transform: scale(0.8);
    filter: drop-shadow(0 0 0 rgba(224, 36, 94, 0));
  }
  50% {
    transform: scale(1.3);
    filter: drop-shadow(0 0 12px rgba(224, 36, 94, 0.8));
  }
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 6px rgba(224, 36, 94, 0.4));
  }
}

/*  Mode sombre : couleur adaptée */
@media (prefers-color-scheme: dark) {
  .wishlist-icon {
    color: #888;
  }
  .wishlist-icon:hover {
    color: #ff7b9a;
  }
  .wishlist-icon .fa-heart.active {
    color: #ff4d73;
    filter: drop-shadow(0 0 10px rgba(255, 77, 115, 0.6));
  }
}

/* ===========================
   TOAST WISHLIST
=========================== */
.wishlist-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #00998B;
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 1rem;
  z-index: 9999;
  box-shadow: 0 4px 14px rgba(0,0,0,0.2);
  opacity: 0.95;
  animation: bounceIn 0.3s ease-out;
}

/*  Mode sombre */
@media (prefers-color-scheme: dark) {
  .wishlist-toast {
    background: #00bfa5;
    color: #0f141b;
  }
}

/* Animation d’apparition */
@keyframes bounceIn {
  0% { transform: translate(-50%, 50px); opacity: 0; }
  60% { transform: translate(-50%, -5px); opacity: 1; }
  100% { transform: translate(-50%, 0); opacity: 1; }
}

/* Transition fade pour disparition douce */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}


</style>
